import { render, staticRenderFns } from "./ExcusedRequest.vue?vue&type=template&id=5c789bf7&scoped=true"
import script from "./ExcusedRequest.vue?vue&type=script&lang=ts"
export * from "./ExcusedRequest.vue?vue&type=script&lang=ts"
import style0 from "./ExcusedRequest.vue?vue&type=style&index=0&id=5c789bf7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c789bf7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
